import { render, staticRenderFns } from "./itemStockInfoBox.vue?vue&type=template&id=317708d3&"
import script from "./itemStockInfoBox.vue?vue&type=script&lang=ts&"
export * from "./itemStockInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports